import React from 'react';
import Link from 'next/link';
import { type RecommendationProduct } from '@/common/types/recommended-products';
import { useDomainStore } from '@/store/use-domain.store';
import AnalyticsWrapper from '@/common/components/analytics-wrapper';
import Price from '@/common/components/price/price.component';
import Text from '@/common/components/text/text.component';
import { appConfigs } from '@/common/configs/app.config';
import { rialToToman } from '@/common/utils/money-exchange.utility';
import ProductDisplay from './product-display.component';

interface ProductProps {
  itemDetail: RecommendationProduct;
}
function Product({ itemDetail }: ProductProps) {
  const {
    productId: id,
    price,
    discount,
    productTitle: name,
    vendorSlug,
    slug,
    ...rest
  } = itemDetail;
  const discountNum = Math.round(discount * 100);
  const isTenant = useDomainStore((store) => store.isTenant);
  const basePath = isTenant ? '/product' : `/${vendorSlug}`;
  const href = `${basePath}/${id}/${slug}`;
  return (
    <AnalyticsWrapper analytics={['product-click-other-product-v1']}>
      <Link className="" id={id?.toString()} href={href}>
        <ProductDisplay
          availability={'InStock'} // --- IGNORE --- all products are in stock in recommendations api
          thumbnailImage={rest.thumbnailImage}
          discount={discountNum}
        />
        <Text className="text-xs font-medium line-clamp-2 text-ellipsis">
          {name}
        </Text>
        <Price
          price={rialToToman(price, appConfigs.rialExchangeRate)}
          discount={discountNum !== 0 ? discountNum : undefined}
          alignment="horizontal"
          priceClassName="text-black-default text-xs font-medium"
          discountClassName="text-black-200 text-[11px] font-normal leading-[18px]"
        />
      </Link>
    </AnalyticsWrapper>
  );
}

export default Product;
